import http from '../http.js'
import { getFpromTidHeaders } from '~/utils/firstPromoter.js'

export const Api = {
  REGISTER: '/lip-sync/api/user/register',
  VERIFY: '/lip-sync/api/user/register/code/verify',
  LOGIN: '/lip-sync/api/user/login/password',
  GOOGLE_LOGIN: '/lip-sync/api/user/login/google',
  LOGOUT: '/lip-sync/api/user/logout',
  GET_USER_INFO: '/lip-sync/api/user/info',
  SIGN_IN: '/lip-sync/api/free-credits/sign-in',
  GET_FREE_CREDITS_OVERVIEW: '/lip-sync/api/free-credits/overview',
  GET_INVITE_INFO: '/lip-sync/api/user/invite',
  SOCIAL_SHARE: '/lip-sync/api/free-credits/social-share',
  SUBMIT_POST_LINK: '/lip-sync/api/free-credits/post-link/submit',
  GET_FREE_CREDITS_HISTORY: '/lip-sync/api/free-credits/history',

  // ###############video################
  // CREATE_TASK:'/lip-sync/api/text-to-video/create-task',
  // GET_TASK_RESULT:'/lip-sync/api/text-to-video/get-task-result',
  GET_TASK_HISTORY: '/lip-sync/api/text-to-video/get-history',
  GET_CHECK_IN_HISTORY: '/lip-sync/api/user/check-in/history',
  CHECK_IN: '/lip-sync/api/user/check-in',
  //支付成功数据返回
  PAY_SUCCESS: '/lip-sync/api/user/add-pay-record',
  // ###############lipsync################
  CREATE_LIP_SYNC_TASK: '/api/aigc/comprehensive/lip-sync/create-task',
  GET_LIP_SYNC_TASK_RESULT: '/api/aigc/comprehensive/lip-sync/get-task-result',
  GET_LIP_SYNC_TASK_HISTORY: '/api/aigc/comprehensive/lip-sync/get-history',
  DELETE_LIP_SYNC_TASK: '/api/aigc/comprehensive/lip-sync/delete-task',
  GET_LIP_SYNC_PROMPT_TRANSLATE:
    '/api/aigc/comprehensive/lip-sync/prompt-translation',
  GET_LIP_SYNC_PROMPT_OPTIMIZE:
    '/api/aigc/comprehensive/lip-sync/prompt-optimize',
  CREATE_AI_PROMPT_OPTIMIZE_TASK:
    '/api/aigc/prompt/prompt-optimize/create-task',
  GET_LIP_SYNC_TEMPLATES:
    '/api/aigc/comprehensive/lip-sync/generated-templates',
  GET_LIP_SYNC_COLLECTION: '/api/aigc/comprehensive/lip-sync/user-collection',
  GET_LIP_SYNC_COLLECTION_DETAIL:
    '/api/aigc/comprehensive/lip-sync/user-uncollection',
  LIP_SYNC_VIDEO_CHECK: '/api/aigc/pre_interface/nsfw-check/video/create-task',
  LIP_SYNC_IMAGE_CHECK: '/api/aigc/pre_interface/nsfw-check/image/create-task',
  LIP_SYNC_GET_VIDEO_CHECK_RESULT:
    '/api/aigc/pre_interface/nsfw-check/task-result',
  TASK_SYNC: '/api/aigc/pre_interface/task_sync',
}

export const register = (data) => http.post(Api.REGISTER, data, { headers: getFpromTidHeaders() })
export const verify = (data) => http.post(Api.VERIFY, data, { headers: getFpromTidHeaders() })
export const login = (data) => http.post(Api.LOGIN, data, { headers: getFpromTidHeaders() })
export const logout = (data) => http.get(Api.LOGOUT, data)
export const googleLogin = (data) => http.post(Api.GOOGLE_LOGIN, data, { headers: getFpromTidHeaders() })
export const getUserInfo = (data) => http.get(Api.GET_USER_INFO, data)
export const signInForFreeCredits = () => http.post(Api.SIGN_IN)
export const getFreeCreditsOverview = () => http.get(Api.GET_FREE_CREDITS_OVERVIEW)
export const getInviteInfo = () => http.get(Api.GET_INVITE_INFO)
export const claimSocialShareCredits = (data) => http.post(Api.SOCIAL_SHARE, data)
export const submitPostLink = (data) => http.post(Api.SUBMIT_POST_LINK, data)
export const getFreeCreditsHistory = ({ page = 1, size = 10 } = {}) =>
  http.get(Api.GET_FREE_CREDITS_HISTORY, { page, size })
export const syncUserVideoTasks = (dataType = 'video') =>
  http.get(Api.TASK_SYNC, { data_type: dataType })

// export const createVidelTask = (data) => http.get(Api.CREATE_TASK, data)
// export const getTaskResult = (data) => http.post(Api.GET_TASK_RESULT, data)
export const getTaskHistory = (data) => http.get(Api.GET_TASK_HISTORY + data)
export const getCheckInHistory = (data) => http.get(Api.GET_CHECK_IN_HISTORY + data)
export const getPayResult = (data) => http.post(Api.PAY_SUCCESS, data)
export const checkIn = (data) => http.post(Api.CHECK_IN, data)

/** Repeat array keys: task_type=a&task_type=b (not task_type[]=a). */
function serializeLipSyncHistoryQuery(params) {
  const parts = [];
  for (const [key, value] of Object.entries(params)) {
    if (value == null || value === "") continue;
    if (Array.isArray(value)) {
      for (const item of value) {
        parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(item))}`);
      }
    } else {
      parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`);
    }
  }
  return parts.length ? `?${parts.join("&")}` : "";
}

/** @param {{ page?: number, size?: number, task_type?: string | string[] } | string} params */
export const getLipSyncTaskHistory = (params = {}) => {
  if (typeof params === "string") {
    return http.get(`${Api.GET_LIP_SYNC_TASK_HISTORY}${params}`);
  }
  return http.get(`${Api.GET_LIP_SYNC_TASK_HISTORY}${serializeLipSyncHistoryQuery(params)}`);
};

export const createLipSyncTask = (data) => http.post(Api.CREATE_LIP_SYNC_TASK, data)

export const getLipSyncTaskResult = (params) =>
  http.get(Api.GET_LIP_SYNC_TASK_RESULT, params)

export const deleteLipSyncTask = (data) => http.post(Api.DELETE_LIP_SYNC_TASK, data)

export const getLipSyncTemplates = (params) =>
  http.get(Api.GET_LIP_SYNC_TEMPLATES, params)

export const addLipSyncTemplateCollection = (data) =>
  http.post(Api.GET_LIP_SYNC_COLLECTION, data)

export const removeLipSyncTemplateCollection = (data) =>
  http.post(Api.GET_LIP_SYNC_COLLECTION_DETAIL, data)

export const translateLipSyncPrompt = (data) =>
  http.post(Api.GET_LIP_SYNC_PROMPT_TRANSLATE, data)

export const optimizeLipSyncPrompt = (data) =>
  http.post(Api.GET_LIP_SYNC_PROMPT_OPTIMIZE, data)

export const createAiPromptOptimizeTask = (data) =>
  http.post(Api.CREATE_AI_PROMPT_OPTIMIZE_TASK, data)

export const submitLipSyncVideoCheck = (data) =>
  http.post(Api.LIP_SYNC_VIDEO_CHECK, data)

export const submitLipSyncImageCheck = (data) =>
  http.post(Api.LIP_SYNC_IMAGE_CHECK, data)

export const getLipSyncVideoCheckResult = (params) =>
  http.get(Api.LIP_SYNC_GET_VIDEO_CHECK_RESULT, params)
